import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RowMultipleOptionsComponent } from '../row-action/row-multiple-options.component';
import { RowTrashComponent } from '../row-action/row-trash.component';
import { RowOptionButtons, RowOptionChoice } from '../single-field.model';

@Component({
    selector: 'r1-compass-lib-field-mapping',
    imports: [CommonModule, MatButtonModule, RowTrashComponent, RowMultipleOptionsComponent],
    template: `
        <div class="mapping-row" [ngStyle]="{ 'align-items': 'center' }">
            <div class="row-form" [ngClass]="index() < totalRequiredRows() ? 'required-row' : 'optional-row'">
                <ng-content />
            </div>

            <!-- Creates the approximate size of the delete and multi option row -->
            @if (rowOptionButtons().length === 0) {
                <div style="visibility: hidden">
                    <button mat-icon-button type="button"></button>
                </div>
            }

            @if (rowOptionButtons().length === 1) {
                @if (rowOptionButtons()[0].value === 'delete') {
                    <r1-compass-lib-row-trash
                        [index]="index()"
                        (removeRow)="removeRow(index())"
                        [ngStyle]="{
                            visibility: index() + 1 > totalRequiredRows() ? 'visible' : 'hidden',
                        }" />
                } @else {
                    <div style="visibility: hidden">
                        <button mat-icon-button type="button"></button>
                    </div>
                }
            }

            @if (rowOptionButtons().length > 1) {
                <r1-compass-lib-row-multiple-options
                    [rowOptions]="rowOptionButtons()"
                    [index]="index()"
                    [totalRequiredRows]="totalRequiredRows()"
                    (clickOption)="selectOptionOfMultiple($event)" />
            }
        </div>
    `,
    styleUrls: ['./field-mapping.component.scss'],
})
export class FieldMappingComponent implements OnInit {
    index = input.required<number>();
    totalRequiredRows = input.required<number>();
    rowOptionButtons = input.required<RowOptionButtons[]>();

    @Output()
    clickOption: EventEmitter<RowOptionChoice> = new EventEmitter<RowOptionChoice>();

    ngOnInit(): void {
        // TODO - make into effect, add `isDev()` check
        this.index() ?? console.error('Field `index` required in `<r1-lib-field-mapping>`');
        this.totalRequiredRows() ?? console.error('Field `totalRequiredRows` required in `<r1-lib-field-mapping>`');
        this.rowOptionButtons() ?? console.error('Field `rowOptionButtons` required in `<r1-lib-field-mapping>`');
    }

    protected removeRow(index: number) {
        this.clickOption.emit({ index: index, ...this.rowOptionButtons()[index] });
    }

    protected selectOptionOfMultiple(option: RowOptionChoice) {
        // TODO - removed spread and index, make sure it works as intended
        this.clickOption.emit(option);
    }
}
